export default __webpack_public_path__ + "static/media/apa-homepage.323a8fad.jpg";